window.API_URL = process.env.API_URL;
window.CDN = process.env.CDN;
window.INTERCOM_API_KEY = process.env.INTERCOM_API_KEY;
window.SEGMENT_KEY = process.env.SEGMENT_KEY;
window.GOOGLE_OAUTH2_CLIENT_ID = process.env.GOOGLE_OAUTH2_CLIENT_ID;
window.FACEBOOK_OAUTH2_CLIENT_ID = process.env.FACEBOOK_OAUTH2_CLIENT_ID;
window.INTERCOM_OAUTH2_CLIENT_ID = process.env.INTERCOM_OAUTH2_CLIENT_ID;
window.BING_ADS_OAUTH2_CLIENT_ID = process.env.BING_ADS_OAUTH2_CLIENT_ID;
window.SALESFORCE_OAUTH2_CLIENT_ID = process.env.SALESFORCE_OAUTH2_CLIENT_ID;
window.SLACK_OAUTH2_CLIENT_ID = process.env.SLACK_OAUTH2_CLIENT_ID;
window.XERO_OAUTH2_CLIENT_ID = process.env.XERO_OAUTH2_CLIENT_ID;
window.LINKED_IN_OAUTH2_CLIENT_ID = process.env.LINKED_IN_OAUTH2_CLIENT_ID;
window.PIPEDRIVE_OAUTH2_CLIENT_ID = process.env.PIPEDRIVE_OAUTH2_CLIENT_ID;
window.APP_NAME = process.env.APP_NAME;
window.STRIPE_PUBLIC_KEY = process.env.STRIPE_PUBLIC_KEY;
window.ACCOUNT_DOCK_PUBLIC_KEY = process.env.ACCOUNT_DOCK_PUBLIC_KEY;
window.APP_URL = process.env.APP_URL;
window.NODE_ENV = process.env.NODE_ENV;
window.INSTAGRAM_OAUTH2_CLIENT_ID = process.env.INSTAGRAM_OAUTH2_CLIENT_ID;
window.SHOPIFY_OAUTH2_CLIENT_ID = process.env.SHOPIFY_OAUTH2_CLIENT_ID;
window.NEW_RELIC_SPA_APP_ID = process.env.NEW_RELIC_SPA_APP_ID;
window.WALKME_SRC = process.env.WALKME_SRC;
window.DEFAULT_REGION_ID = process.env.DEFAULT_REGION_ID;
window.ROLLBAR_ACCESS_TOKEN = process.env.ROLLBAR_ACCESS_TOKEN;
window.SOURCE_VERSION = process.env.SOURCE_VERSION;
window.ROLLBAR_ENV = process.env.ROLLBAR_ENV;
window.PIPEDRIVE_URL = process.env.PIPEDRIVE_URL;
